import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import DataTable from "react-data-table-component";
import IconButton from "@material-ui/core/IconButton";
import DeleteIcon from "@material-ui/icons/Delete";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import ViewHeadlineIcon from "@material-ui/icons/ViewHeadline";
import ClearIcon from "@material-ui/icons/Clear";
import { FilterList, LibraryAddCheck } from "@material-ui/icons";
import {
  Button,
  Divider,
  FormControl,
  Grid,
  MenuItem,
  Select,
  Badge,
  Typography,
  Box,
  Switch,
  FormControlLabel
} from "@material-ui/core";
import Modal from "../../cm_shared/cm_global_modal";
import { Link, withRouter } from "react-router-dom";
import CustomPagination from "../../cm_shared/CMCustomPagination";
import ValidationCheck from "../ValidationCheck";
import StopIcon from "@material-ui/icons/Stop";
import { Tooltip } from "@material-ui/core";
import PlayCircleFilledWhiteIcon from "@material-ui/icons/PlayCircleFilledWhite";
import StartExecution from "../StartExecution";
import HelpIcon from "@material-ui/icons/Help";
import BulkDownloadConfirmationModal from "../../cm_shared/CMBulkDownloadConfirmation";
import HelperComponent from "../../cm_shared/Reporting/CustomHelper/index";
import BulkDownloadModal from "../../cm_shared/CMBulkDownloadPopup/index";
import { LoadingContext } from "../../../../context/spinnerContext";
import styled from "styled-components";
import { makeStyles } from "@material-ui/core/styles";

const customStyles = {
  table: {
    style: {
      border: "solid 1px rgba(0,0,0,.2)",
      borderRadius: "10px",
    },
  },
  rows: {
    style: {
      // minHeight: "72px",
      cursor: "pointer",
      fontSize: 16,
      minHeight: "unset"
    },
  },
  headCells: {
    style: {
      paddingLeft: "8px",
      paddingRight: "8px",
      backgroundColor: "#b0ff45",
      justifyContent: "flex-start",
    },
  },
  cells: {
    style: {
      paddingLeft: "8px",
      paddingRight: "8px",
      fontWeight: "bold",
      justifyContent: "flex-start",
    },
  },
};

const StyledDataTable = styled(DataTable)`
  .rdt_TableBody {
    overflow: auto;
    max-height: calc(100vh - 380px)
  }
`;
const loadingStyles = makeStyles({
  fctwToggle: {
    border: '1px solid rgba(0,0,0,.2)',
    height: '56px',
    width: '135px',
    borderRadius: '5px',
    padding: '0.5rem'
  }
});

const OpenLoopTopologyListing = ({ history }) => {
  const query = new URLSearchParams(window.location.search);
  const openLoopType=query.get("open-loop-type");
  const { setIsLoading } = useContext(LoadingContext);
  const [topologyData, setTopologyData] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [modalContent, setModalContent] = useState(null);
  const rowsPerPageSessionBased = [10, 20, 50, 100, 500];
  const [eventsPerPage, setEventsPerPage] = useState(10);
  const [page, setPage] = useState(0);
  const [total, setTotal] = useState(0);
  const [validationStatus, setValidationStatus] = useState({});
  const [disableEscapeKeyDown, setDisableEscapeKeyDown] = useState(false);
  const [disableBackdropClick, setDisableBackdropClick] = useState(false);
  const [sizeForModal, setSizeForModal] = useState("lg");
  const [selectedRows, setSelectedRows] = useState([]);
  const [clearRows, setClearRows] = useState(false);
  const [modelOptions, setModelOptions] = useState([]);
  const [selectValue, setSelectValue] = useState("");
  const [isBulkDownloadPopupOpen, setBulkDownloadPopup] = useState(false);
  const [downloadConfirm, setDownloadConfirm] = useState(false);
  const [bulkDownloadRes, setBulkDownloadResp] = useState(null);
   const [fctwSelected, setFctwSelected] = useState(false);
   const classes = loadingStyles();
  const handleModalClose = () => {
    setIsOpen(false);
  };

  const initialColumns = [
    {
      name: "Topology Tag Name",
      selector: "topology_tag_name",
      sortable: true,
      grow: 2,
      cell: (row) => {
        return <span>{row.topology_tag_name}</span>;
      },
    },
    {
      name: "Description",
      selector: "description",
      sortable: true,
      cell: (row) => (
        <Link
          to={{
            pathname: "/open_loop/pre-validation/configuration",
            state: {
              cadTopologyId: row.job_id,
              openLoopType
            },
          }}
          style={{ textDecoration: "none" }}
        >
          {row.description}
        </Link>
      ),
    },
    {
      name: "Start Date",
      selector: "start_date",
      sortable: true,
      cell: (row) => {
        return <span>{row.start_date}</span>
      },
    },
    {
      name: "End Date",
      selector: "end_date",
      sortable: true,
      cell: (row) => {
        return (
          <>
            {row.status == "completed" ? row.end_date : null}
          </>
        )
      },
    },
    {
      name: "Actions",
      selector: "progress",
      sortable: false,
      cell: (row) => {
        return (
          <div style={{ display: "flex", justifyContent: "space-around" }}>
                          {row.progress === "running" && row.status === "started" ? (

              <Tooltip placement="top" title={<h6>Stop Execution</h6>}>
                <IconButton onClick={() => handleStop(row.job_id)}>
                  <StopIcon />
                </IconButton>
              </Tooltip>
            ) : validationStatus[row.job_id] ? (
              <Tooltip placement="top" title={<h6>Start Execution</h6>}>
                <IconButton
                  onClick={() => {
                    handleModal(
                      <StartExecution
                        data={row}
                        modelOptions={modelOptions}
                        selectValue={selectValue}
                        setIsOpen={onCloseSuccessPopup}
                        handleClose={handleModalClose}
                      />
                    );
                  }}
                >
                  <PlayCircleFilledWhiteIcon />
                </IconButton>
              </Tooltip>
            ) : (
              <Tooltip placement="top" title={<h6>Validate</h6>}>
                <IconButton
                  onClick={() =>
                    handleModal(
                      <ValidationCheck
                        data={row}
                        handleValidationCheck={() =>
                          handleValidationCheck(row.job_id)
                        }
                      />,
                      true,
                      true,
                      "lg"
                    )
                  }
                >
                  <LibraryAddCheck />
                </IconButton>
              </Tooltip>
            )}
            <Tooltip placement="top" title={<h6>Download</h6>}>
              <IconButton
                disabled={row.file_path === null || row.file_path === ''}
                aria-label="delete"
                onClick={() => handleDownload(row.file_path)}
              >
                <CloudDownloadIcon />
              </IconButton>
            </Tooltip>
            {/* <Tooltip placement="top" title={<h6>Delete</h6>}>
              <IconButton aria-label="delete">
                <DeleteIcon />
              </IconButton>
            </Tooltip> */}
            <Tooltip placement="top" title={<h6>Execution List</h6>}>
              <IconButton
                onClick={() =>
                  history.push({
                    pathname: "/open_loop/execution_listing",
                    search: `?open-loop-type=${openLoopType}`,
                    state: {
                      topology_id: row.job_id,
                      topology_tag_name: row.topology_tag_name,
                      model: row.model_name,
                    },
                  })
                }
              >
                <ViewHeadlineIcon />
              </IconButton>
            </Tooltip>
          </div>
        );
      },
    },
  ];
  const handleFctwToggle = (event) => {
    console.log('event.target.checked', event.target.checked);
    setFctwSelected(event.target.checked);
  }

  const handleChange = async (event) => {
    setSelectedRows(event.selectedRows);
  };

  const bulkDownload = async () => {
    setDownloadConfirm(false);
    try {
      setIsLoading(true);
      const fileList = selectedRows.map(item => {
        return {'file': item.file_path};
      })
      const payload = {
        initiated_from: `${openLoopType} CAD Listing`,
        download_file_name: `${openLoopType}_CAD`,
        page_type: openLoopType,
        files: fileList
      }
      const resp = await axios.post(
        process.env.REACT_APP_API_GATEWAY_URL+"/bulk-download",
        payload
      );
      setBulkDownloadResp(JSON.parse(resp.data));
      setBulkDownloadPopup(true);
    } catch(err) {
      console.log('err', err);
    } finally {
      setIsLoading(false);
      setClearRows(!clearRows);
      setSelectedRows([]);
    }
  };

  const onCloseBulkDownloadPopup = () => {
    setBulkDownloadPopup(false);
    console.log(window.location);
    if (bulkDownloadRes.statusCode === 200) {
      const match = bulkDownloadRes.body.split('name: ')[1];
      window.open(`${window.location.origin}/download_archive_list?latestDownload=${match}`, '_blank');
    }
  }

  const handleDownload = async (filePath) => {
    const fileToDownload = await axios.post("/generate-presigned-url", {
      s3_location: filePath,
    });
    window.open(fileToDownload.data.presigned_url);
  };
  // const handleSelectChange = (event) => {
  //   const newSelectValue = event.target.value;
  //   setSelectValue(newSelectValue);

  //   setPage(0);
  // };

  const fetchSelectOptions = async () => {
    const response = await axios.post(
      "/cm/close_loop/fetch-carmaker_model_record_V2",{
        page:"open_loop"
      }
    );
    setModelOptions(response.data);
    console.log("response.data", response.data);
    if (response.data.length > 0) {
      const defaultSelectValue = response.data[0].value;
      setSelectValue(defaultSelectValue);
    }
  };
  const handleChangeRowsPerPage = (event) => {
    setEventsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const fetchTopolofyListing = async (searchOptions = "{}") => {
    try {
      setIsLoading(true);
    const response = await axios.post(
      `/cm_fetch_open_loop/topology/handler_data?page_number_record=
        ${page + 1}&page_size_record=${eventsPerPage}`,
      {
        page_number_record: page + 1,
        page_size_record: eventsPerPage,
        searchOptions,
        open_loop_type:openLoopType?openLoopType.toUpperCase():null,
        fctw:fctwSelected
      }
    );
    setTopologyData(response.data.items);
    setTotal(response.data.total_records);
    }
    catch(error) {
      console.log("fetching topology list error", error)
    } finally {
      setIsLoading(false)
    }
  };

  const onCloseSuccessPopup = () => {
    setIsOpen(false);
    fetchTopolofyListing(JSON.stringify([{ model_name: [selectValue] }]));
  };

  useEffect(() => {
    fetchSelectOptions();
  }, []);

  useEffect(() => {
    selectValue &&
      fetchTopolofyListing(JSON.stringify([{ model_name: [selectValue] }]));
  }, [eventsPerPage, page, selectValue,fctwSelected]);

  const handleModal = (
    content,
    disableBackdropClick,
    disableEscapeKeyDown,
    size
  ) => {
    setDisableBackdropClick(disableBackdropClick ? true : false);
    setDisableEscapeKeyDown(disableBackdropClick ? true : false);
    setSizeForModal(size ? size : "lg");
    setModalContent(content);
    setIsOpen(true);
  };

  const handleValidationCheck = (job_id, allChecksPassed) => {
    setValidationStatus((prevStatus) => ({
      ...prevStatus,
      [job_id]: true,
    }));
    setIsOpen(false);
  };

  const handleStop = (job_id) => {
    axios.delete(
      `/cm_open_loop/stop/virtual-validation?topology_uuid=${job_id}`
    );
  };
  return (
    <div
      style={{
        padding: "0.6rem",
        position: "relative",
        background: "white",
        margin: "10px",
        borderRadius: "10px",
        height: "calc(100% - 120px)"
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          backgroundColor: "white",
          padding: "5px",
          width: "100%",
        }}
      >
        <Typography variant="h5">
          <Link to="/welcome">Open Loop </Link> {">"} Topology {">"} {openLoopType && openLoopType.toUpperCase()}
        </Typography>
        <div>
          <Tooltip placement="top" title={<h6>Help</h6>}>
            <IconButton
              color="inherit"
              onClick={() =>
                handleModal(
                  <HelperComponent
                    closeHandler={setIsOpen}
                    contentController={[
                      {
                        value: "tutorialVideo",
                        label: "Tutorial",
                        tutorials:[{
                        videoURL: "/video/openloopCADtopology.mp4",
                        text: "In this tutorial, we will have a walkthrough on how to use the open loop CAD topology listing.",
                        title: "Close loop | Topology"}]
                      },
                    ]}
                    defaultSelector="tutorialVideo"
                  />,
                  true,
                  true
                )
              }
            >
              <Badge max={5000} color="secondary">
                <HelpIcon />
              </Badge>
            </IconButton>
          </Tooltip>
          {selectedRows.length !== 0 && (
            <Tooltip placement="top" title={<h6>Download</h6>}>
              <IconButton color="inherit" onClick={() => setDownloadConfirm(true)}>
                <Badge
                  badgeContent={selectedRows.length}
                  max={5000}
                  color="secondary"
                >
                  <CloudDownloadIcon />
                </Badge>
              </IconButton>
            </Tooltip>
          )}
        </div>
      </div>
      <Divider />
      <Modal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        content={modalContent}
        size={sizeForModal}
        disableEscapeKeyDown={disableEscapeKeyDown}
        disableBackdropClick={disableBackdropClick}
      />
      {isBulkDownloadPopupOpen && <BulkDownloadModal
        title={"Bulk Download Status"}
        isOpen={isBulkDownloadPopupOpen}
        onClosePopup={onCloseBulkDownloadPopup}
        content={bulkDownloadRes.body}
      />}
      {downloadConfirm && <BulkDownloadConfirmationModal
        isOpen={downloadConfirm}
        onClosePopup={setDownloadConfirm}
        onClickYes={bulkDownload}
      />}
      <Grid
        container
        spacing={3}
        style={{
          marginTop: "5px",
          marginBottom: "5px",
          justifyContent: "space-between",
        }}
      >
        {/* <Grid item /> */}
        <Grid item>
        {/* {modelOptions && !!modelOptions.length && (
        <FormControl
          variant="outlined"
          style={{ minWidth: 200, marginBottom: "10px" }}
        >
          <Select
            value={selectValue}
            onChange={handleSelectChange}
            MenuProps={{
              getContentAnchorEl: null,
              anchorOrigin: {
                vertical: "bottom",
                horizontal: "left",
              },
              transformOrigin: {
                vertical: "top",
                horizontal: "left",
              },
            }}
          >
            {modelOptions.map((option) => (
              <MenuItem key={option._id} value={option.value}>
                {option.value}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )} */}
      
          {/* <Box style={{display:"none"}}>
          <Button
            variant="contained"
            style={{ backgroundColor: "#622ad8", color: "white" }}
            startIcon={<FilterList />}
          >
            Filter
          </Button>

          <Button variant="outlined" startIcon={<ClearIcon />} color="">
            Clear
          </Button>
          </Box> */}
            {openLoopType === 'PG' && <FormControlLabel
                  className={classes.fctwToggle}
                  value="start"
                  control={
                    <Switch
                      checked={fctwSelected}
                      onChange={handleFctwToggle}
                      color="primary"
                      name="fctw"
                    />
                  }
                  label="FCTW"
                  labelPlacement="start"
                /> }
        </Grid>

        <Grid item>
          <CustomPagination
            total={total}
            rowsPerPageOptions={rowsPerPageSessionBased}
            eventsPerPage={eventsPerPage}
            page={page}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
            onPageChange={(event, newPage) => setPage(newPage)}
          ></CustomPagination>
        </Grid>
        </Grid>

    
    

      {initialColumns.length > 0 ? (
        <StyledDataTable
          selectableRows
          selectableRowDisabled={(row) => row.file_path === null || row.file_path === ''}
          onSelectedRowsChange={handleChange}
          selectableRowSelected={(row) =>
            selectedRows.some((obj) =>
              Object.keys(obj).some((key) => obj[key] === row.job_id)
            )
          }
          clearSelectedRows={clearRows}
          columns={initialColumns}
          data={topologyData}
          customStyles={customStyles}
        ></StyledDataTable>
      ) : null}
    </div>
  );
};

export default withRouter(OpenLoopTopologyListing);